import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

import { IPermission } from '../../../utils/interfaces/profile';
import { IResponse } from '../../../utils/interfaces/response';
import { PermissionService } from '../permission.service';

export const getAllPermissionResolver: ResolveFn<
  Observable<IResponse<IPermission[]>>
> = (route, state) => {
  const permissionService = inject(PermissionService);
  return permissionService.getAllPermission();
};
